import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const StatesItemLabel = styled.div`
  display: inline-block;
  width: 92px;
  margin: 8px 5px 0 0;
  color: ${COLORS.gray60};
`;

export default StatesItemLabel;
